/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthKontrollpunktselectRouteImport } from './routes/_auth/_kontrollpunktselect'
import { Route as AuthBarriererRouteImport } from './routes/_auth/barrierer'
import { Route as AuthGrunndataRouteImport } from './routes/_auth/grunndata'
import { Route as AuthHjelpRouteImport } from './routes/_auth/hjelp'
import { Route as AuthInnstillingerRouteImport } from './routes/_auth/innstillinger'
import { Route as AuthKartRouteImport } from './routes/_auth/kart'
import { Route as AuthKritikalitetRouteImport } from './routes/_auth/kritikalitet'
import { Route as AuthStrategiRouteImport } from './routes/_auth/strategi'
import { Route as AuthTilstandRouteImport } from './routes/_auth/tilstand'
import { Route as AuthTilstandsutviklingRouteImport } from './routes/_auth/tilstandsutvikling'
import { Route as AuthTrendRouteImport } from './routes/_auth/trend'
import { Route as AuthGrunndataIndexRouteImport } from './routes/_auth/grunndata/index'
import { Route as AuthGrunndataSystemNameRouteImport } from './routes/_auth/grunndata/$systemName'
import { Route as AuthInnstillingerIndexRouteImport } from './routes/_auth/innstillinger/index'
import { Route as AuthInnstillingerIntegrasjonRouteImport } from './routes/_auth/innstillinger/integrasjon'
import { Route as AuthInnstillingerOpplastingRouteImport } from './routes/_auth/innstillinger/opplasting'
import { Route as AuthKartAssetRouteImport } from './routes/_auth/kart/asset'
import { Route as AuthKartAssetGroupRouteImport } from './routes/_auth/kart/assetGroup'
import { Route as AuthStrategiIndexRouteImport } from './routes/_auth/strategi/index'
import { Route as AuthStrategiEconomicZoneRouteImport } from './routes/_auth/strategi/economic-zone'
import { Route as AuthStrategiInspectionPointRouteImport } from './routes/_auth/strategi/inspection-point'
import { Route as AuthKontrollpunktselectKontrollpunkterIndexRouteImport } from './routes/_auth/_kontrollpunktselect/kontrollpunkter/index'
import { Route as AuthKontrollpunktselectKontrollpunkterIpCodeRouteImport } from './routes/_auth/_kontrollpunktselect/kontrollpunkter/$ipCode'
import { Route as AuthGrunndataSystemNameIndexRouteImport } from './routes/_auth/grunndata/$systemName/index'
import { Route as AuthGrunndataSystemNameAssetGroupNameRouteImport } from './routes/_auth/grunndata/$systemName/$assetGroupName'
import { Route as AuthInnstillingerOpplastingUploadTypeRouteImport } from './routes/_auth/innstillinger/opplasting/$uploadType'
import { Route as AuthKartAssetAssetNameRouteImport } from './routes/_auth/kart/asset/$assetName'
import { Route as AuthKartAssetGroupAssetGroupNameRouteImport } from './routes/_auth/kart/assetGroup/$assetGroupName'
import { Route as AuthStrategiVedlikeholdsveilederIndexRouteImport } from './routes/_auth/strategi/vedlikeholdsveileder/index'
import { Route as AuthStrategiVedlikeholdsveilederAssetGroupNameRouteImport } from './routes/_auth/strategi/vedlikeholdsveileder/$assetGroupName'
import { Route as AuthGrunndataSystemNameAssetGroupNameIndexRouteImport } from './routes/_auth/grunndata/$systemName/$assetGroupName/index'
import { Route as AuthGrunndataSystemNameAssetGroupNameAssetNameRouteImport } from './routes/_auth/grunndata/$systemName/$assetGroupName/$assetName'
import { Route as AuthKartAssetGroupAssetGroupNameAssetsRouteImport } from './routes/_auth/kart/assetGroup/$assetGroupName/assets'
import { Route as AuthKartAssetGroupAssetGroupNameStatesRouteImport } from './routes/_auth/kart/assetGroup/$assetGroupName/states'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKontrollpunktselectRoute = AuthKontrollpunktselectRouteImport.update({
  id: '/_kontrollpunktselect',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBarriererRoute = AuthBarriererRouteImport.update({
  id: '/barrierer',
  path: '/barrierer',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGrunndataRoute = AuthGrunndataRouteImport.update({
  id: '/grunndata',
  path: '/grunndata',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHjelpRoute = AuthHjelpRouteImport.update({
  id: '/hjelp',
  path: '/hjelp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInnstillingerRoute = AuthInnstillingerRouteImport.update({
  id: '/innstillinger',
  path: '/innstillinger',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKartRoute = AuthKartRouteImport.update({
  id: '/kart',
  path: '/kart',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKritikalitetRoute = AuthKritikalitetRouteImport.update({
  id: '/kritikalitet',
  path: '/kritikalitet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStrategiRoute = AuthStrategiRouteImport.update({
  id: '/strategi',
  path: '/strategi',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTilstandRoute = AuthTilstandRouteImport.update({
  id: '/tilstand',
  path: '/tilstand',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTilstandsutviklingRoute = AuthTilstandsutviklingRouteImport.update({
  id: '/tilstandsutvikling',
  path: '/tilstandsutvikling',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTrendRoute = AuthTrendRouteImport.update({
  id: '/trend',
  path: '/trend',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGrunndataIndexRoute = AuthGrunndataIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthGrunndataRoute,
} as any)
const AuthGrunndataSystemNameRoute = AuthGrunndataSystemNameRouteImport.update({
  id: '/$systemName',
  path: '/$systemName',
  getParentRoute: () => AuthGrunndataRoute,
} as any)
const AuthInnstillingerIndexRoute = AuthInnstillingerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthInnstillingerRoute,
} as any)
const AuthInnstillingerIntegrasjonRoute =
  AuthInnstillingerIntegrasjonRouteImport.update({
    id: '/integrasjon',
    path: '/integrasjon',
    getParentRoute: () => AuthInnstillingerRoute,
  } as any)
const AuthInnstillingerOpplastingRoute =
  AuthInnstillingerOpplastingRouteImport.update({
    id: '/opplasting',
    path: '/opplasting',
    getParentRoute: () => AuthInnstillingerRoute,
  } as any)
const AuthKartAssetRoute = AuthKartAssetRouteImport.update({
  id: '/asset',
  path: '/asset',
  getParentRoute: () => AuthKartRoute,
} as any)
const AuthKartAssetGroupRoute = AuthKartAssetGroupRouteImport.update({
  id: '/assetGroup',
  path: '/assetGroup',
  getParentRoute: () => AuthKartRoute,
} as any)
const AuthStrategiIndexRoute = AuthStrategiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthStrategiRoute,
} as any)
const AuthStrategiEconomicZoneRoute =
  AuthStrategiEconomicZoneRouteImport.update({
    id: '/economic-zone',
    path: '/economic-zone',
    getParentRoute: () => AuthStrategiRoute,
  } as any)
const AuthStrategiInspectionPointRoute =
  AuthStrategiInspectionPointRouteImport.update({
    id: '/inspection-point',
    path: '/inspection-point',
    getParentRoute: () => AuthStrategiRoute,
  } as any)
const AuthKontrollpunktselectKontrollpunkterIndexRoute =
  AuthKontrollpunktselectKontrollpunkterIndexRouteImport.update({
    id: '/kontrollpunkter/',
    path: '/kontrollpunkter/',
    getParentRoute: () => AuthKontrollpunktselectRoute,
  } as any)
const AuthKontrollpunktselectKontrollpunkterIpCodeRoute =
  AuthKontrollpunktselectKontrollpunkterIpCodeRouteImport.update({
    id: '/kontrollpunkter/$ipCode',
    path: '/kontrollpunkter/$ipCode',
    getParentRoute: () => AuthKontrollpunktselectRoute,
  } as any)
const AuthGrunndataSystemNameIndexRoute =
  AuthGrunndataSystemNameIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGrunndataSystemNameRoute,
  } as any)
const AuthGrunndataSystemNameAssetGroupNameRoute =
  AuthGrunndataSystemNameAssetGroupNameRouteImport.update({
    id: '/$assetGroupName',
    path: '/$assetGroupName',
    getParentRoute: () => AuthGrunndataSystemNameRoute,
  } as any)
const AuthInnstillingerOpplastingUploadTypeRoute =
  AuthInnstillingerOpplastingUploadTypeRouteImport.update({
    id: '/$uploadType',
    path: '/$uploadType',
    getParentRoute: () => AuthInnstillingerOpplastingRoute,
  } as any)
const AuthKartAssetAssetNameRoute = AuthKartAssetAssetNameRouteImport.update({
  id: '/$assetName',
  path: '/$assetName',
  getParentRoute: () => AuthKartAssetRoute,
} as any)
const AuthKartAssetGroupAssetGroupNameRoute =
  AuthKartAssetGroupAssetGroupNameRouteImport.update({
    id: '/$assetGroupName',
    path: '/$assetGroupName',
    getParentRoute: () => AuthKartAssetGroupRoute,
  } as any)
const AuthStrategiVedlikeholdsveilederIndexRoute =
  AuthStrategiVedlikeholdsveilederIndexRouteImport.update({
    id: '/vedlikeholdsveileder/',
    path: '/vedlikeholdsveileder/',
    getParentRoute: () => AuthStrategiRoute,
  } as any)
const AuthStrategiVedlikeholdsveilederAssetGroupNameRoute =
  AuthStrategiVedlikeholdsveilederAssetGroupNameRouteImport.update({
    id: '/vedlikeholdsveileder/$assetGroupName',
    path: '/vedlikeholdsveileder/$assetGroupName',
    getParentRoute: () => AuthStrategiRoute,
  } as any)
const AuthGrunndataSystemNameAssetGroupNameIndexRoute =
  AuthGrunndataSystemNameAssetGroupNameIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGrunndataSystemNameAssetGroupNameRoute,
  } as any)
const AuthGrunndataSystemNameAssetGroupNameAssetNameRoute =
  AuthGrunndataSystemNameAssetGroupNameAssetNameRouteImport.update({
    id: '/$assetName',
    path: '/$assetName',
    getParentRoute: () => AuthGrunndataSystemNameAssetGroupNameRoute,
  } as any)
const AuthKartAssetGroupAssetGroupNameAssetsRoute =
  AuthKartAssetGroupAssetGroupNameAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthKartAssetGroupAssetGroupNameRoute,
  } as any)
const AuthKartAssetGroupAssetGroupNameStatesRoute =
  AuthKartAssetGroupAssetGroupNameStatesRouteImport.update({
    id: '/states',
    path: '/states',
    getParentRoute: () => AuthKartAssetGroupAssetGroupNameRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AuthIndexRoute
  '/barrierer': typeof AuthBarriererRoute
  '/grunndata': typeof AuthGrunndataRouteWithChildren
  '/hjelp': typeof AuthHjelpRoute
  '/innstillinger': typeof AuthInnstillingerRouteWithChildren
  '/kart': typeof AuthKartRouteWithChildren
  '/kritikalitet': typeof AuthKritikalitetRoute
  '/strategi': typeof AuthStrategiRouteWithChildren
  '/tilstand': typeof AuthTilstandRoute
  '/tilstandsutvikling': typeof AuthTilstandsutviklingRoute
  '/trend': typeof AuthTrendRoute
  '/grunndata/$systemName': typeof AuthGrunndataSystemNameRouteWithChildren
  '/innstillinger/integrasjon': typeof AuthInnstillingerIntegrasjonRoute
  '/innstillinger/opplasting': typeof AuthInnstillingerOpplastingRouteWithChildren
  '/kart/asset': typeof AuthKartAssetRouteWithChildren
  '/kart/assetGroup': typeof AuthKartAssetGroupRouteWithChildren
  '/strategi/economic-zone': typeof AuthStrategiEconomicZoneRoute
  '/strategi/inspection-point': typeof AuthStrategiInspectionPointRoute
  '/grunndata/': typeof AuthGrunndataIndexRoute
  '/innstillinger/': typeof AuthInnstillingerIndexRoute
  '/strategi/': typeof AuthStrategiIndexRoute
  '/kontrollpunkter/$ipCode': typeof AuthKontrollpunktselectKontrollpunkterIpCodeRoute
  '/grunndata/$systemName/$assetGroupName': typeof AuthGrunndataSystemNameAssetGroupNameRouteWithChildren
  '/innstillinger/opplasting/$uploadType': typeof AuthInnstillingerOpplastingUploadTypeRoute
  '/kart/asset/$assetName': typeof AuthKartAssetAssetNameRoute
  '/kart/assetGroup/$assetGroupName': typeof AuthKartAssetGroupAssetGroupNameRouteWithChildren
  '/strategi/vedlikeholdsveileder/$assetGroupName': typeof AuthStrategiVedlikeholdsveilederAssetGroupNameRoute
  '/kontrollpunkter/': typeof AuthKontrollpunktselectKontrollpunkterIndexRoute
  '/grunndata/$systemName/': typeof AuthGrunndataSystemNameIndexRoute
  '/strategi/vedlikeholdsveileder/': typeof AuthStrategiVedlikeholdsveilederIndexRoute
  '/grunndata/$systemName/$assetGroupName/$assetName': typeof AuthGrunndataSystemNameAssetGroupNameAssetNameRoute
  '/kart/assetGroup/$assetGroupName/assets': typeof AuthKartAssetGroupAssetGroupNameAssetsRoute
  '/kart/assetGroup/$assetGroupName/states': typeof AuthKartAssetGroupAssetGroupNameStatesRoute
  '/grunndata/$systemName/$assetGroupName/': typeof AuthGrunndataSystemNameAssetGroupNameIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/': typeof AuthIndexRoute
  '/barrierer': typeof AuthBarriererRoute
  '/hjelp': typeof AuthHjelpRoute
  '/kart': typeof AuthKartRouteWithChildren
  '/kritikalitet': typeof AuthKritikalitetRoute
  '/tilstand': typeof AuthTilstandRoute
  '/tilstandsutvikling': typeof AuthTilstandsutviklingRoute
  '/trend': typeof AuthTrendRoute
  '/innstillinger/integrasjon': typeof AuthInnstillingerIntegrasjonRoute
  '/innstillinger/opplasting': typeof AuthInnstillingerOpplastingRouteWithChildren
  '/kart/asset': typeof AuthKartAssetRouteWithChildren
  '/kart/assetGroup': typeof AuthKartAssetGroupRouteWithChildren
  '/strategi/economic-zone': typeof AuthStrategiEconomicZoneRoute
  '/strategi/inspection-point': typeof AuthStrategiInspectionPointRoute
  '/grunndata': typeof AuthGrunndataIndexRoute
  '/innstillinger': typeof AuthInnstillingerIndexRoute
  '/strategi': typeof AuthStrategiIndexRoute
  '/kontrollpunkter/$ipCode': typeof AuthKontrollpunktselectKontrollpunkterIpCodeRoute
  '/innstillinger/opplasting/$uploadType': typeof AuthInnstillingerOpplastingUploadTypeRoute
  '/kart/asset/$assetName': typeof AuthKartAssetAssetNameRoute
  '/kart/assetGroup/$assetGroupName': typeof AuthKartAssetGroupAssetGroupNameRouteWithChildren
  '/strategi/vedlikeholdsveileder/$assetGroupName': typeof AuthStrategiVedlikeholdsveilederAssetGroupNameRoute
  '/kontrollpunkter': typeof AuthKontrollpunktselectKontrollpunkterIndexRoute
  '/grunndata/$systemName': typeof AuthGrunndataSystemNameIndexRoute
  '/strategi/vedlikeholdsveileder': typeof AuthStrategiVedlikeholdsveilederIndexRoute
  '/grunndata/$systemName/$assetGroupName/$assetName': typeof AuthGrunndataSystemNameAssetGroupNameAssetNameRoute
  '/kart/assetGroup/$assetGroupName/assets': typeof AuthKartAssetGroupAssetGroupNameAssetsRoute
  '/kart/assetGroup/$assetGroupName/states': typeof AuthKartAssetGroupAssetGroupNameStatesRoute
  '/grunndata/$systemName/$assetGroupName': typeof AuthGrunndataSystemNameAssetGroupNameIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/_kontrollpunktselect': typeof AuthKontrollpunktselectRouteWithChildren
  '/_auth/barrierer': typeof AuthBarriererRoute
  '/_auth/grunndata': typeof AuthGrunndataRouteWithChildren
  '/_auth/hjelp': typeof AuthHjelpRoute
  '/_auth/innstillinger': typeof AuthInnstillingerRouteWithChildren
  '/_auth/kart': typeof AuthKartRouteWithChildren
  '/_auth/kritikalitet': typeof AuthKritikalitetRoute
  '/_auth/strategi': typeof AuthStrategiRouteWithChildren
  '/_auth/tilstand': typeof AuthTilstandRoute
  '/_auth/tilstandsutvikling': typeof AuthTilstandsutviklingRoute
  '/_auth/trend': typeof AuthTrendRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/grunndata/$systemName': typeof AuthGrunndataSystemNameRouteWithChildren
  '/_auth/innstillinger/integrasjon': typeof AuthInnstillingerIntegrasjonRoute
  '/_auth/innstillinger/opplasting': typeof AuthInnstillingerOpplastingRouteWithChildren
  '/_auth/kart/asset': typeof AuthKartAssetRouteWithChildren
  '/_auth/kart/assetGroup': typeof AuthKartAssetGroupRouteWithChildren
  '/_auth/strategi/economic-zone': typeof AuthStrategiEconomicZoneRoute
  '/_auth/strategi/inspection-point': typeof AuthStrategiInspectionPointRoute
  '/_auth/grunndata/': typeof AuthGrunndataIndexRoute
  '/_auth/innstillinger/': typeof AuthInnstillingerIndexRoute
  '/_auth/strategi/': typeof AuthStrategiIndexRoute
  '/_auth/_kontrollpunktselect/kontrollpunkter/$ipCode': typeof AuthKontrollpunktselectKontrollpunkterIpCodeRoute
  '/_auth/grunndata/$systemName/$assetGroupName': typeof AuthGrunndataSystemNameAssetGroupNameRouteWithChildren
  '/_auth/innstillinger/opplasting/$uploadType': typeof AuthInnstillingerOpplastingUploadTypeRoute
  '/_auth/kart/asset/$assetName': typeof AuthKartAssetAssetNameRoute
  '/_auth/kart/assetGroup/$assetGroupName': typeof AuthKartAssetGroupAssetGroupNameRouteWithChildren
  '/_auth/strategi/vedlikeholdsveileder/$assetGroupName': typeof AuthStrategiVedlikeholdsveilederAssetGroupNameRoute
  '/_auth/_kontrollpunktselect/kontrollpunkter/': typeof AuthKontrollpunktselectKontrollpunkterIndexRoute
  '/_auth/grunndata/$systemName/': typeof AuthGrunndataSystemNameIndexRoute
  '/_auth/strategi/vedlikeholdsveileder/': typeof AuthStrategiVedlikeholdsveilederIndexRoute
  '/_auth/grunndata/$systemName/$assetGroupName/$assetName': typeof AuthGrunndataSystemNameAssetGroupNameAssetNameRoute
  '/_auth/kart/assetGroup/$assetGroupName/assets': typeof AuthKartAssetGroupAssetGroupNameAssetsRoute
  '/_auth/kart/assetGroup/$assetGroupName/states': typeof AuthKartAssetGroupAssetGroupNameStatesRoute
  '/_auth/grunndata/$systemName/$assetGroupName/': typeof AuthGrunndataSystemNameAssetGroupNameIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/barrierer'
    | '/grunndata'
    | '/hjelp'
    | '/innstillinger'
    | '/kart'
    | '/kritikalitet'
    | '/strategi'
    | '/tilstand'
    | '/tilstandsutvikling'
    | '/trend'
    | '/grunndata/$systemName'
    | '/innstillinger/integrasjon'
    | '/innstillinger/opplasting'
    | '/kart/asset'
    | '/kart/assetGroup'
    | '/strategi/economic-zone'
    | '/strategi/inspection-point'
    | '/grunndata/'
    | '/innstillinger/'
    | '/strategi/'
    | '/kontrollpunkter/$ipCode'
    | '/grunndata/$systemName/$assetGroupName'
    | '/innstillinger/opplasting/$uploadType'
    | '/kart/asset/$assetName'
    | '/kart/assetGroup/$assetGroupName'
    | '/strategi/vedlikeholdsveileder/$assetGroupName'
    | '/kontrollpunkter/'
    | '/grunndata/$systemName/'
    | '/strategi/vedlikeholdsveileder/'
    | '/grunndata/$systemName/$assetGroupName/$assetName'
    | '/kart/assetGroup/$assetGroupName/assets'
    | '/kart/assetGroup/$assetGroupName/states'
    | '/grunndata/$systemName/$assetGroupName/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/barrierer'
    | '/hjelp'
    | '/kart'
    | '/kritikalitet'
    | '/tilstand'
    | '/tilstandsutvikling'
    | '/trend'
    | '/innstillinger/integrasjon'
    | '/innstillinger/opplasting'
    | '/kart/asset'
    | '/kart/assetGroup'
    | '/strategi/economic-zone'
    | '/strategi/inspection-point'
    | '/grunndata'
    | '/innstillinger'
    | '/strategi'
    | '/kontrollpunkter/$ipCode'
    | '/innstillinger/opplasting/$uploadType'
    | '/kart/asset/$assetName'
    | '/kart/assetGroup/$assetGroupName'
    | '/strategi/vedlikeholdsveileder/$assetGroupName'
    | '/kontrollpunkter'
    | '/grunndata/$systemName'
    | '/strategi/vedlikeholdsveileder'
    | '/grunndata/$systemName/$assetGroupName/$assetName'
    | '/kart/assetGroup/$assetGroupName/assets'
    | '/kart/assetGroup/$assetGroupName/states'
    | '/grunndata/$systemName/$assetGroupName'
  id:
    | '__root__'
    | '/$'
    | '/_auth'
    | '/_auth/_kontrollpunktselect'
    | '/_auth/barrierer'
    | '/_auth/grunndata'
    | '/_auth/hjelp'
    | '/_auth/innstillinger'
    | '/_auth/kart'
    | '/_auth/kritikalitet'
    | '/_auth/strategi'
    | '/_auth/tilstand'
    | '/_auth/tilstandsutvikling'
    | '/_auth/trend'
    | '/_auth/'
    | '/_auth/grunndata/$systemName'
    | '/_auth/innstillinger/integrasjon'
    | '/_auth/innstillinger/opplasting'
    | '/_auth/kart/asset'
    | '/_auth/kart/assetGroup'
    | '/_auth/strategi/economic-zone'
    | '/_auth/strategi/inspection-point'
    | '/_auth/grunndata/'
    | '/_auth/innstillinger/'
    | '/_auth/strategi/'
    | '/_auth/_kontrollpunktselect/kontrollpunkter/$ipCode'
    | '/_auth/grunndata/$systemName/$assetGroupName'
    | '/_auth/innstillinger/opplasting/$uploadType'
    | '/_auth/kart/asset/$assetName'
    | '/_auth/kart/assetGroup/$assetGroupName'
    | '/_auth/strategi/vedlikeholdsveileder/$assetGroupName'
    | '/_auth/_kontrollpunktselect/kontrollpunkter/'
    | '/_auth/grunndata/$systemName/'
    | '/_auth/strategi/vedlikeholdsveileder/'
    | '/_auth/grunndata/$systemName/$assetGroupName/$assetName'
    | '/_auth/kart/assetGroup/$assetGroupName/assets'
    | '/_auth/kart/assetGroup/$assetGroupName/states'
    | '/_auth/grunndata/$systemName/$assetGroupName/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_kontrollpunktselect': {
      id: '/_auth/_kontrollpunktselect'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthKontrollpunktselectRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/barrierer': {
      id: '/_auth/barrierer'
      path: '/barrierer'
      fullPath: '/barrierer'
      preLoaderRoute: typeof AuthBarriererRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grunndata': {
      id: '/_auth/grunndata'
      path: '/grunndata'
      fullPath: '/grunndata'
      preLoaderRoute: typeof AuthGrunndataRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hjelp': {
      id: '/_auth/hjelp'
      path: '/hjelp'
      fullPath: '/hjelp'
      preLoaderRoute: typeof AuthHjelpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/innstillinger': {
      id: '/_auth/innstillinger'
      path: '/innstillinger'
      fullPath: '/innstillinger'
      preLoaderRoute: typeof AuthInnstillingerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kart': {
      id: '/_auth/kart'
      path: '/kart'
      fullPath: '/kart'
      preLoaderRoute: typeof AuthKartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kritikalitet': {
      id: '/_auth/kritikalitet'
      path: '/kritikalitet'
      fullPath: '/kritikalitet'
      preLoaderRoute: typeof AuthKritikalitetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/strategi': {
      id: '/_auth/strategi'
      path: '/strategi'
      fullPath: '/strategi'
      preLoaderRoute: typeof AuthStrategiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tilstand': {
      id: '/_auth/tilstand'
      path: '/tilstand'
      fullPath: '/tilstand'
      preLoaderRoute: typeof AuthTilstandRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tilstandsutvikling': {
      id: '/_auth/tilstandsutvikling'
      path: '/tilstandsutvikling'
      fullPath: '/tilstandsutvikling'
      preLoaderRoute: typeof AuthTilstandsutviklingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/trend': {
      id: '/_auth/trend'
      path: '/trend'
      fullPath: '/trend'
      preLoaderRoute: typeof AuthTrendRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/grunndata/': {
      id: '/_auth/grunndata/'
      path: '/'
      fullPath: '/grunndata/'
      preLoaderRoute: typeof AuthGrunndataIndexRouteImport
      parentRoute: typeof AuthGrunndataRoute
    }
    '/_auth/grunndata/$systemName': {
      id: '/_auth/grunndata/$systemName'
      path: '/$systemName'
      fullPath: '/grunndata/$systemName'
      preLoaderRoute: typeof AuthGrunndataSystemNameRouteImport
      parentRoute: typeof AuthGrunndataRoute
    }
    '/_auth/innstillinger/': {
      id: '/_auth/innstillinger/'
      path: '/'
      fullPath: '/innstillinger/'
      preLoaderRoute: typeof AuthInnstillingerIndexRouteImport
      parentRoute: typeof AuthInnstillingerRoute
    }
    '/_auth/innstillinger/integrasjon': {
      id: '/_auth/innstillinger/integrasjon'
      path: '/integrasjon'
      fullPath: '/innstillinger/integrasjon'
      preLoaderRoute: typeof AuthInnstillingerIntegrasjonRouteImport
      parentRoute: typeof AuthInnstillingerRoute
    }
    '/_auth/innstillinger/opplasting': {
      id: '/_auth/innstillinger/opplasting'
      path: '/opplasting'
      fullPath: '/innstillinger/opplasting'
      preLoaderRoute: typeof AuthInnstillingerOpplastingRouteImport
      parentRoute: typeof AuthInnstillingerRoute
    }
    '/_auth/kart/asset': {
      id: '/_auth/kart/asset'
      path: '/asset'
      fullPath: '/kart/asset'
      preLoaderRoute: typeof AuthKartAssetRouteImport
      parentRoute: typeof AuthKartRoute
    }
    '/_auth/kart/assetGroup': {
      id: '/_auth/kart/assetGroup'
      path: '/assetGroup'
      fullPath: '/kart/assetGroup'
      preLoaderRoute: typeof AuthKartAssetGroupRouteImport
      parentRoute: typeof AuthKartRoute
    }
    '/_auth/strategi/': {
      id: '/_auth/strategi/'
      path: '/'
      fullPath: '/strategi/'
      preLoaderRoute: typeof AuthStrategiIndexRouteImport
      parentRoute: typeof AuthStrategiRoute
    }
    '/_auth/strategi/economic-zone': {
      id: '/_auth/strategi/economic-zone'
      path: '/economic-zone'
      fullPath: '/strategi/economic-zone'
      preLoaderRoute: typeof AuthStrategiEconomicZoneRouteImport
      parentRoute: typeof AuthStrategiRoute
    }
    '/_auth/strategi/inspection-point': {
      id: '/_auth/strategi/inspection-point'
      path: '/inspection-point'
      fullPath: '/strategi/inspection-point'
      preLoaderRoute: typeof AuthStrategiInspectionPointRouteImport
      parentRoute: typeof AuthStrategiRoute
    }
    '/_auth/_kontrollpunktselect/kontrollpunkter/': {
      id: '/_auth/_kontrollpunktselect/kontrollpunkter/'
      path: '/kontrollpunkter'
      fullPath: '/kontrollpunkter/'
      preLoaderRoute: typeof AuthKontrollpunktselectKontrollpunkterIndexRouteImport
      parentRoute: typeof AuthKontrollpunktselectRoute
    }
    '/_auth/_kontrollpunktselect/kontrollpunkter/$ipCode': {
      id: '/_auth/_kontrollpunktselect/kontrollpunkter/$ipCode'
      path: '/kontrollpunkter/$ipCode'
      fullPath: '/kontrollpunkter/$ipCode'
      preLoaderRoute: typeof AuthKontrollpunktselectKontrollpunkterIpCodeRouteImport
      parentRoute: typeof AuthKontrollpunktselectRoute
    }
    '/_auth/grunndata/$systemName/': {
      id: '/_auth/grunndata/$systemName/'
      path: '/'
      fullPath: '/grunndata/$systemName/'
      preLoaderRoute: typeof AuthGrunndataSystemNameIndexRouteImport
      parentRoute: typeof AuthGrunndataSystemNameRoute
    }
    '/_auth/grunndata/$systemName/$assetGroupName': {
      id: '/_auth/grunndata/$systemName/$assetGroupName'
      path: '/$assetGroupName'
      fullPath: '/grunndata/$systemName/$assetGroupName'
      preLoaderRoute: typeof AuthGrunndataSystemNameAssetGroupNameRouteImport
      parentRoute: typeof AuthGrunndataSystemNameRoute
    }
    '/_auth/innstillinger/opplasting/$uploadType': {
      id: '/_auth/innstillinger/opplasting/$uploadType'
      path: '/$uploadType'
      fullPath: '/innstillinger/opplasting/$uploadType'
      preLoaderRoute: typeof AuthInnstillingerOpplastingUploadTypeRouteImport
      parentRoute: typeof AuthInnstillingerOpplastingRoute
    }
    '/_auth/kart/asset/$assetName': {
      id: '/_auth/kart/asset/$assetName'
      path: '/$assetName'
      fullPath: '/kart/asset/$assetName'
      preLoaderRoute: typeof AuthKartAssetAssetNameRouteImport
      parentRoute: typeof AuthKartAssetRoute
    }
    '/_auth/kart/assetGroup/$assetGroupName': {
      id: '/_auth/kart/assetGroup/$assetGroupName'
      path: '/$assetGroupName'
      fullPath: '/kart/assetGroup/$assetGroupName'
      preLoaderRoute: typeof AuthKartAssetGroupAssetGroupNameRouteImport
      parentRoute: typeof AuthKartAssetGroupRoute
    }
    '/_auth/strategi/vedlikeholdsveileder/': {
      id: '/_auth/strategi/vedlikeholdsveileder/'
      path: '/vedlikeholdsveileder'
      fullPath: '/strategi/vedlikeholdsveileder/'
      preLoaderRoute: typeof AuthStrategiVedlikeholdsveilederIndexRouteImport
      parentRoute: typeof AuthStrategiRoute
    }
    '/_auth/strategi/vedlikeholdsveileder/$assetGroupName': {
      id: '/_auth/strategi/vedlikeholdsveileder/$assetGroupName'
      path: '/vedlikeholdsveileder/$assetGroupName'
      fullPath: '/strategi/vedlikeholdsveileder/$assetGroupName'
      preLoaderRoute: typeof AuthStrategiVedlikeholdsveilederAssetGroupNameRouteImport
      parentRoute: typeof AuthStrategiRoute
    }
    '/_auth/grunndata/$systemName/$assetGroupName/': {
      id: '/_auth/grunndata/$systemName/$assetGroupName/'
      path: '/'
      fullPath: '/grunndata/$systemName/$assetGroupName/'
      preLoaderRoute: typeof AuthGrunndataSystemNameAssetGroupNameIndexRouteImport
      parentRoute: typeof AuthGrunndataSystemNameAssetGroupNameRoute
    }
    '/_auth/grunndata/$systemName/$assetGroupName/$assetName': {
      id: '/_auth/grunndata/$systemName/$assetGroupName/$assetName'
      path: '/$assetName'
      fullPath: '/grunndata/$systemName/$assetGroupName/$assetName'
      preLoaderRoute: typeof AuthGrunndataSystemNameAssetGroupNameAssetNameRouteImport
      parentRoute: typeof AuthGrunndataSystemNameAssetGroupNameRoute
    }
    '/_auth/kart/assetGroup/$assetGroupName/assets': {
      id: '/_auth/kart/assetGroup/$assetGroupName/assets'
      path: '/assets'
      fullPath: '/kart/assetGroup/$assetGroupName/assets'
      preLoaderRoute: typeof AuthKartAssetGroupAssetGroupNameAssetsRouteImport
      parentRoute: typeof AuthKartAssetGroupAssetGroupNameRoute
    }
    '/_auth/kart/assetGroup/$assetGroupName/states': {
      id: '/_auth/kart/assetGroup/$assetGroupName/states'
      path: '/states'
      fullPath: '/kart/assetGroup/$assetGroupName/states'
      preLoaderRoute: typeof AuthKartAssetGroupAssetGroupNameStatesRouteImport
      parentRoute: typeof AuthKartAssetGroupAssetGroupNameRoute
    }
  }
}

interface AuthKontrollpunktselectRouteChildren {
  AuthKontrollpunktselectKontrollpunkterIpCodeRoute: typeof AuthKontrollpunktselectKontrollpunkterIpCodeRoute
  AuthKontrollpunktselectKontrollpunkterIndexRoute: typeof AuthKontrollpunktselectKontrollpunkterIndexRoute
}

const AuthKontrollpunktselectRouteChildren: AuthKontrollpunktselectRouteChildren =
  {
    AuthKontrollpunktselectKontrollpunkterIpCodeRoute:
      AuthKontrollpunktselectKontrollpunkterIpCodeRoute,
    AuthKontrollpunktselectKontrollpunkterIndexRoute:
      AuthKontrollpunktselectKontrollpunkterIndexRoute,
  }

const AuthKontrollpunktselectRouteWithChildren =
  AuthKontrollpunktselectRoute._addFileChildren(
    AuthKontrollpunktselectRouteChildren,
  )

interface AuthGrunndataSystemNameAssetGroupNameRouteChildren {
  AuthGrunndataSystemNameAssetGroupNameAssetNameRoute: typeof AuthGrunndataSystemNameAssetGroupNameAssetNameRoute
  AuthGrunndataSystemNameAssetGroupNameIndexRoute: typeof AuthGrunndataSystemNameAssetGroupNameIndexRoute
}

const AuthGrunndataSystemNameAssetGroupNameRouteChildren: AuthGrunndataSystemNameAssetGroupNameRouteChildren =
  {
    AuthGrunndataSystemNameAssetGroupNameAssetNameRoute:
      AuthGrunndataSystemNameAssetGroupNameAssetNameRoute,
    AuthGrunndataSystemNameAssetGroupNameIndexRoute:
      AuthGrunndataSystemNameAssetGroupNameIndexRoute,
  }

const AuthGrunndataSystemNameAssetGroupNameRouteWithChildren =
  AuthGrunndataSystemNameAssetGroupNameRoute._addFileChildren(
    AuthGrunndataSystemNameAssetGroupNameRouteChildren,
  )

interface AuthGrunndataSystemNameRouteChildren {
  AuthGrunndataSystemNameAssetGroupNameRoute: typeof AuthGrunndataSystemNameAssetGroupNameRouteWithChildren
  AuthGrunndataSystemNameIndexRoute: typeof AuthGrunndataSystemNameIndexRoute
}

const AuthGrunndataSystemNameRouteChildren: AuthGrunndataSystemNameRouteChildren =
  {
    AuthGrunndataSystemNameAssetGroupNameRoute:
      AuthGrunndataSystemNameAssetGroupNameRouteWithChildren,
    AuthGrunndataSystemNameIndexRoute: AuthGrunndataSystemNameIndexRoute,
  }

const AuthGrunndataSystemNameRouteWithChildren =
  AuthGrunndataSystemNameRoute._addFileChildren(
    AuthGrunndataSystemNameRouteChildren,
  )

interface AuthGrunndataRouteChildren {
  AuthGrunndataSystemNameRoute: typeof AuthGrunndataSystemNameRouteWithChildren
  AuthGrunndataIndexRoute: typeof AuthGrunndataIndexRoute
}

const AuthGrunndataRouteChildren: AuthGrunndataRouteChildren = {
  AuthGrunndataSystemNameRoute: AuthGrunndataSystemNameRouteWithChildren,
  AuthGrunndataIndexRoute: AuthGrunndataIndexRoute,
}

const AuthGrunndataRouteWithChildren = AuthGrunndataRoute._addFileChildren(
  AuthGrunndataRouteChildren,
)

interface AuthInnstillingerOpplastingRouteChildren {
  AuthInnstillingerOpplastingUploadTypeRoute: typeof AuthInnstillingerOpplastingUploadTypeRoute
}

const AuthInnstillingerOpplastingRouteChildren: AuthInnstillingerOpplastingRouteChildren =
  {
    AuthInnstillingerOpplastingUploadTypeRoute:
      AuthInnstillingerOpplastingUploadTypeRoute,
  }

const AuthInnstillingerOpplastingRouteWithChildren =
  AuthInnstillingerOpplastingRoute._addFileChildren(
    AuthInnstillingerOpplastingRouteChildren,
  )

interface AuthInnstillingerRouteChildren {
  AuthInnstillingerIntegrasjonRoute: typeof AuthInnstillingerIntegrasjonRoute
  AuthInnstillingerOpplastingRoute: typeof AuthInnstillingerOpplastingRouteWithChildren
  AuthInnstillingerIndexRoute: typeof AuthInnstillingerIndexRoute
}

const AuthInnstillingerRouteChildren: AuthInnstillingerRouteChildren = {
  AuthInnstillingerIntegrasjonRoute: AuthInnstillingerIntegrasjonRoute,
  AuthInnstillingerOpplastingRoute:
    AuthInnstillingerOpplastingRouteWithChildren,
  AuthInnstillingerIndexRoute: AuthInnstillingerIndexRoute,
}

const AuthInnstillingerRouteWithChildren =
  AuthInnstillingerRoute._addFileChildren(AuthInnstillingerRouteChildren)

interface AuthKartAssetRouteChildren {
  AuthKartAssetAssetNameRoute: typeof AuthKartAssetAssetNameRoute
}

const AuthKartAssetRouteChildren: AuthKartAssetRouteChildren = {
  AuthKartAssetAssetNameRoute: AuthKartAssetAssetNameRoute,
}

const AuthKartAssetRouteWithChildren = AuthKartAssetRoute._addFileChildren(
  AuthKartAssetRouteChildren,
)

interface AuthKartAssetGroupAssetGroupNameRouteChildren {
  AuthKartAssetGroupAssetGroupNameAssetsRoute: typeof AuthKartAssetGroupAssetGroupNameAssetsRoute
  AuthKartAssetGroupAssetGroupNameStatesRoute: typeof AuthKartAssetGroupAssetGroupNameStatesRoute
}

const AuthKartAssetGroupAssetGroupNameRouteChildren: AuthKartAssetGroupAssetGroupNameRouteChildren =
  {
    AuthKartAssetGroupAssetGroupNameAssetsRoute:
      AuthKartAssetGroupAssetGroupNameAssetsRoute,
    AuthKartAssetGroupAssetGroupNameStatesRoute:
      AuthKartAssetGroupAssetGroupNameStatesRoute,
  }

const AuthKartAssetGroupAssetGroupNameRouteWithChildren =
  AuthKartAssetGroupAssetGroupNameRoute._addFileChildren(
    AuthKartAssetGroupAssetGroupNameRouteChildren,
  )

interface AuthKartAssetGroupRouteChildren {
  AuthKartAssetGroupAssetGroupNameRoute: typeof AuthKartAssetGroupAssetGroupNameRouteWithChildren
}

const AuthKartAssetGroupRouteChildren: AuthKartAssetGroupRouteChildren = {
  AuthKartAssetGroupAssetGroupNameRoute:
    AuthKartAssetGroupAssetGroupNameRouteWithChildren,
}

const AuthKartAssetGroupRouteWithChildren =
  AuthKartAssetGroupRoute._addFileChildren(AuthKartAssetGroupRouteChildren)

interface AuthKartRouteChildren {
  AuthKartAssetRoute: typeof AuthKartAssetRouteWithChildren
  AuthKartAssetGroupRoute: typeof AuthKartAssetGroupRouteWithChildren
}

const AuthKartRouteChildren: AuthKartRouteChildren = {
  AuthKartAssetRoute: AuthKartAssetRouteWithChildren,
  AuthKartAssetGroupRoute: AuthKartAssetGroupRouteWithChildren,
}

const AuthKartRouteWithChildren = AuthKartRoute._addFileChildren(
  AuthKartRouteChildren,
)

interface AuthStrategiRouteChildren {
  AuthStrategiEconomicZoneRoute: typeof AuthStrategiEconomicZoneRoute
  AuthStrategiInspectionPointRoute: typeof AuthStrategiInspectionPointRoute
  AuthStrategiIndexRoute: typeof AuthStrategiIndexRoute
  AuthStrategiVedlikeholdsveilederAssetGroupNameRoute: typeof AuthStrategiVedlikeholdsveilederAssetGroupNameRoute
  AuthStrategiVedlikeholdsveilederIndexRoute: typeof AuthStrategiVedlikeholdsveilederIndexRoute
}

const AuthStrategiRouteChildren: AuthStrategiRouteChildren = {
  AuthStrategiEconomicZoneRoute: AuthStrategiEconomicZoneRoute,
  AuthStrategiInspectionPointRoute: AuthStrategiInspectionPointRoute,
  AuthStrategiIndexRoute: AuthStrategiIndexRoute,
  AuthStrategiVedlikeholdsveilederAssetGroupNameRoute:
    AuthStrategiVedlikeholdsveilederAssetGroupNameRoute,
  AuthStrategiVedlikeholdsveilederIndexRoute:
    AuthStrategiVedlikeholdsveilederIndexRoute,
}

const AuthStrategiRouteWithChildren = AuthStrategiRoute._addFileChildren(
  AuthStrategiRouteChildren,
)

interface AuthRouteChildren {
  AuthKontrollpunktselectRoute: typeof AuthKontrollpunktselectRouteWithChildren
  AuthBarriererRoute: typeof AuthBarriererRoute
  AuthGrunndataRoute: typeof AuthGrunndataRouteWithChildren
  AuthHjelpRoute: typeof AuthHjelpRoute
  AuthInnstillingerRoute: typeof AuthInnstillingerRouteWithChildren
  AuthKartRoute: typeof AuthKartRouteWithChildren
  AuthKritikalitetRoute: typeof AuthKritikalitetRoute
  AuthStrategiRoute: typeof AuthStrategiRouteWithChildren
  AuthTilstandRoute: typeof AuthTilstandRoute
  AuthTilstandsutviklingRoute: typeof AuthTilstandsutviklingRoute
  AuthTrendRoute: typeof AuthTrendRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthKontrollpunktselectRoute: AuthKontrollpunktselectRouteWithChildren,
  AuthBarriererRoute: AuthBarriererRoute,
  AuthGrunndataRoute: AuthGrunndataRouteWithChildren,
  AuthHjelpRoute: AuthHjelpRoute,
  AuthInnstillingerRoute: AuthInnstillingerRouteWithChildren,
  AuthKartRoute: AuthKartRouteWithChildren,
  AuthKritikalitetRoute: AuthKritikalitetRoute,
  AuthStrategiRoute: AuthStrategiRouteWithChildren,
  AuthTilstandRoute: AuthTilstandRoute,
  AuthTilstandsutviklingRoute: AuthTilstandsutviklingRoute,
  AuthTrendRoute: AuthTrendRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
